module.exports = __webpack_public_path__ + "img/ring_r_l_1_0@3x.74a59955.png";